// extracted by css-extract-rspack-plugin
export default {"orderedList":"src-OrderedList-orderedList-6136b10f"};